import { forwardRef } from 'react';
import { Download, FileText, FileSpreadsheet, ChevronDown } from 'lucide-react';

export interface ExportDropdownProps {
  isOpen: boolean;
  onToggle: () => void;
  onClose: () => void;
  onExportCSV: () => void;
  onExportExcel: () => void;
}

export const ExportDropdown = forwardRef<HTMLDivElement, ExportDropdownProps>(
  ({ isOpen, onToggle, onClose, onExportCSV, onExportExcel }, ref) => {
    const handleExportCSV = () => {
      onExportCSV();
      onClose();
    };

    const handleExportExcel = () => {
      onExportExcel();
      onClose();
    };

    return (
      <div className="relative" ref={ref}>
        <button
          type="button"
          onClick={onToggle}
          className="flex items-center gap-1.5 px-2.5 py-1.5 text-[12px] font-medium text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-md transition-colors"
          title="Export"
        >
          <Download className="w-4 h-4" />
          Export
          <ChevronDown className="w-3 h-3" />
        </button>
        {isOpen && (
          <div className="absolute top-full right-0 mt-1 w-36 bg-white border border-gray-200 rounded-lg shadow-lg z-50 py-1">
            <button
              onClick={handleExportCSV}
              className="w-full flex items-center gap-2 px-3 py-2 text-[12px] text-gray-700 hover:bg-gray-50 text-left transition-colors"
            >
              <FileText className="w-4 h-4 text-gray-400" />
              Export as CSV
            </button>
            <button
              onClick={handleExportExcel}
              className="w-full flex items-center gap-2 px-3 py-2 text-[12px] text-gray-700 hover:bg-gray-50 text-left transition-colors"
            >
              <FileSpreadsheet className="w-4 h-4 text-gray-400" />
              Export as Excel
            </button>
          </div>
        )}
      </div>
    );
  }
);

ExportDropdown.displayName = 'ExportDropdown';
